import { api } from '@/shared/axios-client';
import { useMutation } from '@tanstack/react-query';

export interface JobStatusResponse {
  message?: string;
  title?: string;
  status?: string;
}

export const getJobPRStatus = (jobId: string): Promise<JobStatusResponse> =>
  api.get(`/api/jobs/${jobId}/pr-status`);

export const getJobBuildStatus = (jobId: string): Promise<JobStatusResponse> =>
  api.get(`/api/jobs/${jobId}/check-pipeline`);

export const useCheckPRStatus = () =>
  useMutation({ mutationFn: (jobId: string) => getJobPRStatus(jobId) });

export const useCheckBuildStatus = () =>
  useMutation({ mutationFn: (jobId: string) => getJobBuildStatus(jobId) });
